import {fromJS, List, Map} from 'immutable';

import {
  LOAD_GRADES_FULFILLED,
  LOAD_GRADES_PENDING,
  LOAD_GRADES_REJECTED,
} from '../../../shared/actions';

import {
  LOAD_TITLES_FULFILLED,
  LOAD_TITLES_PENDING,
  LOAD_TITLES_REJECTED,
  RESET_USER_PROFILE_FORM,
  SET_USER_PROFILE_FORM,
  SUBMIT_USER_PROFILE_FORM_FULFILLED,
  SUBMIT_USER_PROFILE_FORM_PENDING,
  SUBMIT_USER_PROFILE_FORM_REJECTED,
} from '../../actions';

import * as actionTypes from '../../../authentication/actions/types';

const initialState = new Map({
  loading: false,
  submitting: false,
  titles: new List(),
  grades: new List(),
  model: new Map({
    firstName: '',
    lastName: '',
    username: '',
    title: '',
    gradeIds: [],
    imageSet: ''
  }),
});

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_GRADES_PENDING:
    case LOAD_TITLES_PENDING:
      return state.set('loading', true);

    case LOAD_GRADES_REJECTED:
    case LOAD_TITLES_REJECTED:
      return state.set('loading', false);

    case LOAD_GRADES_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('grades', fromJS(action.payload.data)));

    case LOAD_TITLES_FULFILLED:
      return state.withMutations(map =>
        map.set('loading', false)
          .set('titles', fromJS(action.payload.data)));

    case SUBMIT_USER_PROFILE_FORM_PENDING:
      return state.set('submitting', true);

    case SUBMIT_USER_PROFILE_FORM_FULFILLED:
      return state.set('submitting', false);

    case SUBMIT_USER_PROFILE_FORM_REJECTED:
      return state.set('submitting', false);

    case RESET_USER_PROFILE_FORM:
      return initialState;

    case actionTypes.LOAD_IDENTITY_FULFILLED:
    case actionTypes.LOGIN_FULFILLED:
      if (action.payload.data && action.payload.data.profile) {
        return state.withMutations(map =>
          map.set('model', fromJS(action.payload.data.profile))
            .setIn(['model', 'gradeIds'], action.payload.data.profile.gradeIds));
      }
      return state;

    case SET_USER_PROFILE_FORM:
      return state.setIn(['model', action.payload.name], action.payload.value);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/userProfile/reducers/pages/setUserProfile.js